import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { GT2FormPageAbstract } from '../../content/abstract/GT2FormPageAbstract';
import { ApiBenching, APICallBenching } from '../api-benching';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-benching-dialog',
  templateUrl: './benching-dialog.component.html',
  styleUrls: ['./benching-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    TranslateModule,
    MatDialogModule,
    CommonModule,
  ],
})
export class BenchingDialogComponent
  extends GT2FormPageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  callStack?: APICallBenching[];

  constructor(public compDialogRef: MatDialogRef<BenchingDialogComponent>) {
    super();
  }

  ngOnInit() {
    this.callStack = ApiBenching.callStack;
    ApiBenching.callStackChanged.subscribe({
      next: (callStack) => {
        this.callStack = callStack;
      },
    });
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public clearStack(): void {
    ApiBenching.clearStack();
  }
}
